import notifications from 'notifications';

export default function showRefreshBenchlingToast(): void {
  notifications.info('A newer version of Benchling is available.', {
    actionText: 'Refresh',
    closeable: false,
    onActionClick: () => {
      window.location.reload();
    },
  });
}
